import React, { useState, useEffect, useMemo, useRef } from "react";
import { useNavigate } from "react-router-dom";
import styles from "./ProductsList.module.css";
import { encoded } from "@/utils";

import { encodeFileNameOnly } from "@utils";

const ProductsList = React.memo(
  ({
    title = "",
    list = [
      {
        id: "",
        image: "",
        title: "",
        description: "",
        leftButtonNm: "",
        leftLink: "",
        rightButtonNm: "",
        rightLink: "",
      },
    ],
    defaultUrl = "",
    updateUrl = "",
    isUpdate = false,
    isDelete = false,
    isReset = false,
    setDeletes = () => {},
    resetDeletes = () => {},
  }) => {
    const insRef = useRef(null);
    const defaultState = {
      onLoad: false,
    };
    const [state, setState] = useState({
      ...defaultState,
    });

    const resetState = () => {
      setState({ ...defaultState });
    };
    const addOnLoadClass = () => {
      setState((s) => ({ ...s, onLoad: true }));
    };
    const adKey = useMemo(() => new Date().getTime(), []);

    useEffect(() => {
      if (isReset) {
        resetState();
      }
      const callbackId = requestIdleCallback(addOnLoadClass);
      return () => {
        resetState();
        cancelIdleCallback(callbackId);
      };
    }, [isReset, isUpdate, list]);
    return (
      <div className={styles.groupBuyArea}>
        <div className={styles.subTitle}>
          <span className={styles.groupBuy}>{title}</span>
          <div className={styles.subTitleUnderline} />
        </div>
        {list.length === 0 ? null : (
          <div className={styles.groupBuyList}>
            {list.length === 0
              ? null
              : list.map((content, idx) => (
                  <Content
                    key={idx}
                    id={content.id}
                    image={content.image}
                    title={content.title}
                    description={content.description}
                    defaultUrl={defaultUrl}
                    updateUrl={updateUrl}
                    isUpdate={isUpdate}
                    isDelete={isDelete}
                    isReset={isReset}
                    time={adKey}
                    setDeletes={setDeletes}
                    resetDeletes={resetDeletes}
                    leftButtonNm={content.leftButtonNm}
                    leftLink={content.leftLink}
                    rightButtonNm={content.rightButtonNm}
                    rightLink={content.rightLink}
                    isGroupBuy={content.isGroupBuy}
                  />
                ))}
          </div>
        )}
        <div className={styles.jointPurchaseArea}>
          <div className={styles.jointPurchaseTitleArea}>
            <div
              className={`${styles.jointPurchaseImage} ${styles.adImageBanner}`}
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <iframe
                src="https://ads-partners.coupang.com/widgets.html?id=894012&template=banner&trackingCode=AF9156469&subId=&width=300&height=250"
                width="236px"
                height="197px"
                frameBorder="0"
                scrolling="no"
                referrerPolicy="unsafe-url"
                browsingtopics={true.toString()}
              ></iframe>
            </div>
            <div className={styles.jointPurchaseTitleDescription}>
              <div className={styles.titleSection}>
                <span className={styles.completeKetogenicDiet}>광고</span>
              </div>
            </div>
          </div>
          <div className={styles.jointPurchaseProductDetailsArea}>
            <div
              className={styles.productDetailsSection}
              style={{ color: "#898460" }}
            >
              이 포스팅은 쿠팡 파트너스 활동의 일환으로, 이에 따른 일정액의
              수수료를 제공받습니다.
            </div>
            <div className={styles.buyButtonArea}>
              <div className={styles.submitButton}></div>
              <div className={styles.submitButton4}></div>
            </div>
          </div>
        </div>
      </div>
    );
  }
);

const Content = React.memo(
  ({
    id = "",
    image = "",
    title = "",
    description = "",
    defaultUrl = "",
    updateUrl = "",
    isUpdate = false,
    isDelete = false,
    isReset = false,
    time = 1,
    leftButtonNm = "",
    leftLink = "",
    rightButtonNm = "",
    rightLink = "",
    setDeletes = () => {},
    resetDeletes = () => {},
    isGroupBuy = true,
  }) => {
    const navigate = useNavigate();
    const defaultState = {
      onOff: false,
    };
    const [state, setState] = useState({
      ...defaultState,
    });

    const resetState = () => {
      setState({ ...defaultState });
    };
    const click = () => {
      if (!isUpdate && !isDelete) {
        return;
      }
      if (isUpdate) {
        const randomTag = new Date().getTime();
        const info = encoded(
          {
            id: id,
            productsNm: title,
            description: description,
            image: image,
            isGroupBuy,
            isLeft: !!leftButtonNm,
            isRight: !!rightButtonNm,
            leftButtonNm,
            rightButtonNm,
            leftLink,
            rightLink,
          },
          true
        );
        navigate(`${updateUrl}/${randomTag}/${info}`);
        return;
      }
      if (isDelete) {
        setState((s) => ({ ...s, onOff: !s.onOff }));
        return;
      }
    };
    const imageStyle = {
      backgroundImage: `url(${encodeFileNameOnly(
        image
      )}?t=${time}), linear-gradient(to bottom, #f5f5f54D, #f0f0f04D)`,
      backgroundRepeat: "no-repeat, no-repeat",
      backgroundPosition: "center",
      backgroundSize: "contain, cover",
    };
    const clickedRightLink = () => {
      if (rightButtonNm && rightLink) {
        window.location.replace(`${rightLink}`);
      }
    };
    const clickedLeftLink = () => {
      if (leftButtonNm && leftLink) {
        window.location.replace(`${leftLink}`);
      }
    };

    useEffect(() => {
      if (isReset) {
        resetState();
      }
      return () => {
        resetState();
      };
    }, [isReset]);
    useEffect(() => {
      if (isDelete && state.onOff) {
        setDeletes({ index: id });
      } else if (isDelete && !state.onOff) {
        resetDeletes({ index: id });
      }
    }, [isDelete, state.onOff]);
    return (
      <div className={styles.jointPurchaseArea} onClick={click}>
        <div className={styles.jointPurchaseTitleArea}>
          <div className={styles.jointPurchaseImage} style={imageStyle}>
            {isDelete && state.onOff && (
              <div className={styles.listOverlay}>
                <div className={styles.checkIcon} />
              </div>
            )}
          </div>
          <div className={styles.jointPurchaseTitleDescription}>
            <div className={styles.titleSection}>
              <span className={styles.completeKetogenicDiet}>{title}</span>
            </div>
          </div>
        </div>
        <div className={styles.jointPurchaseProductDetailsArea}>
          <div className={styles.productDetailsSection}>{description}</div>
          <div className={styles.buyButtonArea}>
            {leftButtonNm && leftLink && (
              <div className={styles.submitButton}>
                <button
                  type="button"
                  className={styles.buttonContainer}
                  onClick={clickedLeftLink}
                >
                  <span className={styles.registerBuy}>{leftButtonNm}</span>
                </button>
              </div>
            )}
            {rightButtonNm && rightLink && (
              <div className={styles.submitButton4}>
                <button
                  type="button"
                  className={styles.buttonContainer5}
                  onClick={clickedRightLink}
                >
                  <span className={styles.registerSpan}>{rightButtonNm}</span>
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
);

export default ProductsList;
